import React from "react";
import {
  FaFileContract,
  FaDonate,
  FaUserShield,
  FaCopyright,
  FaExternalLinkAlt,
  FaBalanceScale,
  FaSyncAlt,
  FaGavel,
  FaEnvelope,
} from "react-icons/fa";

const TermsOfService = () => {
  const sections = [
    {
      icon: <FaDonate />,
      title: "1. Donations",
      points: [
        <>
          All donations made to Aabharan Foundation are voluntary and
          non-refundable except as outlined in our{" "}
          <a
            href="/refund-policy"
            className="text-[#1298b5] hover:text-[#f97316] hover:underline font-semibold"
          >
            Refund Policy
          </a>
          .
        </>,
        "By donating, you confirm that you are at least 18 years old and have the legal authority to make the donation.",
        "Donations are used to support our charitable programs; we reserve the right to allocate funds where they are needed most.",
      ],
    },
    {
      icon: <FaUserShield />,
      title: "2. User Conduct",
      points: [
        "You agree to use the website only for lawful purposes and in a manner that does not infringe the rights of others.",
        "You must not attempt to disrupt or compromise the security or functionality of the site.",
        "Any content you post, such as comments or messages, must not be offensive, abusive, or violate any law.",
      ],
    },
    {
      icon: <FaCopyright />,
      title: "3. Intellectual Property",
      points: [
        "All content on this website, including text, graphics, logos, images, and software, is the property of Aabharan Foundation and is protected by copyright and other laws.",
        "You may not reproduce, distribute, or modify any content without our prior written consent.",
      ],
    },
    {
      icon: <FaExternalLinkAlt />,
      title: "4. Third-Party Links",
      points: [
        "Our website may contain links to external sites that are not operated by us. We have no control over their content and assume no responsibility.",
        "We encourage you to review the privacy policies and terms of any third-party sites you visit.",
      ],
    },
    {
      icon: <FaBalanceScale />,
      title: "5. Limitation of Liability",
      points: [
        "To the fullest extent permitted by law, Aabharan Foundation shall not be liable for any indirect, incidental, or consequential damages arising from your use of this website.",
        "We do not guarantee that the website will be error-free, secure, or continuously available.",
      ],
    },
    {
      icon: <FaSyncAlt />,
      title: "6. Changes to Terms",
      points: [
        'We may update these Terms of Service from time to time. The latest version will always be posted on this page with an updated "Last updated" date.',
        "Your continued use of the website after any changes constitutes acceptance of the new terms.",
      ],
    },
    {
      icon: <FaGavel />,
      title: "7. Governing Law",
      points: [
        "These terms shall be governed by and construed in accordance with the laws of India.",
        "Any disputes arising under these terms shall be subject to the exclusive jurisdiction of the courts in Chandauli, Uttar Pradesh.",
      ],
    },
    {
      icon: <FaEnvelope />,
      title: "8. Contact Us",
      points: [
        <>
          If you have any questions about these Terms, please contact us at{" "}
          <a
            href="mailto:directors@aabharan.org"
            className="text-[#1298b5] hover:text-[#f97316] hover:underline font-semibold"
          >
            directors@aabharan.org
          </a>
          .
        </>,
      ],
    },
  ];

  return (
    <div className="relative min-h-screen overflow-hidden bg-gradient-to-br from-[#eafaff] via-white to-[#dff7fb] py-14 px-4 sm:px-6 lg:px-8">
      <div className="absolute top-16 left-8 w-72 h-72 bg-[#1298b5]/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-16 right-8 w-80 h-80 bg-[#f97316]/10 rounded-full blur-3xl"></div>

      <div className="relative max-w-4xl mx-auto bg-white/95 backdrop-blur-sm rounded-3xl shadow-2xl overflow-hidden border border-[#d8f4f8]">
        <div className="bg-gradient-to-r from-[#1298b5] to-[#0b819b] px-6 py-8 md:px-10 text-white">
          <div className="w-16 h-16 bg-white/20 rounded-2xl flex items-center justify-center text-2xl mb-4">
            <FaFileContract />
          </div>

          <h1 className="text-3xl md:text-4xl font-extrabold">
            Terms of Service
          </h1>

          <p className="text-white/80 mt-2 text-sm">
            Please read these terms carefully before using our website.
          </p>
        </div>

        <div className="px-6 py-8 md:px-10 space-y-8">
          <p className="text-gray-700 leading-relaxed text-lg">
            Welcome to Aabharan Foundation. By accessing or using our website,
            you agree to be bound by these Terms of Service. If you do not agree
            with any part, please refrain from using our site.
          </p>

          {sections.map((section, index) => (
            <section
              key={index}
              className="bg-[#f8fdfe] border border-[#d8f4f8] rounded-2xl p-5"
            >
              <h2 className="text-xl md:text-2xl font-extrabold text-[#073b4c] mb-4 flex items-center gap-3 border-b border-[#d8f4f8] pb-3">
                <span className="w-10 h-10 rounded-xl bg-[#eafaff] text-[#1298b5] flex items-center justify-center text-lg flex-shrink-0">
                  {section.icon}
                </span>
                {section.title}
              </h2>

              <ul className="space-y-3 text-gray-700">
                {section.points.map((point, i) => (
                  <li key={i} className="flex items-start gap-3">
                    <span className="w-2 h-2 rounded-full bg-[#f97316] mt-2 flex-shrink-0"></span>
                    <span className="leading-relaxed">{point}</span>
                  </li>
                ))}
              </ul>
            </section>
          ))}

          <p className="text-xs text-gray-400 pt-4 border-t border-[#d8f4f8]">
            Last updated: March 2026
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;